import { CategoryApi } from '@hem/portal-gateway-axios'
import { AccountApi, AuthenticationApi, EducationsApi } from '@hem/portal-gateway-axios'
import { notification } from '@hem/ui'
import { getEnvVariable } from '@hem/utils'
import AxiosInstance from 'axios'
import { getCookie } from 'cookies-next'

import { onAxiosResponseError } from './api-error-handler'

export const getPortalGatewaySDK = () => {
  const env = getEnvVariable()
  const accessToken = getCookie('user')
  if (!accessToken) {
    notification.error({ message: 'Access denied! Please login again!' })
    window.location.replace(`${env.origin}/login`)
  }
  const apiBased = (<string>env.baseURL).replace('/v1', '')

  const axiosInstance = AxiosInstance.create({
    baseURL: apiBased,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
  axiosInstance.interceptors.response.use(function onSuccess(response) {
    return response
  }, onAxiosResponseError)

  const category = new CategoryApi({ isJsonMime: () => true }, apiBased, axiosInstance)
  const accounts = new AccountApi({ isJsonMime: () => true }, apiBased, axiosInstance)
  const educations = new EducationsApi({ isJsonMime: () => true }, apiBased, axiosInstance)
  const authentication = new AuthenticationApi({ isJsonMime: () => true }, apiBased, axiosInstance)

  return {
    category,
    accounts,
    educations,
    authentication
  }
}
